var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ReportCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M43,40H5c-1.105,0-2-0.895-2-2V10c0-1.105,0.895-2,2-2h38c1.105,0,2,0.895,2,2v28 C45,39.105,44.105,40,43,40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M30.5,19h-21C9.224,19,9,18.776,9,18.5v-1C9,17.224,9.224,17,9.5,17h21c0.276,0,0.5,0.224,0.5,0.5v1 C31,18.776,30.776,19,30.5,19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M36.453,19.773l-1.227-1.227c-0.302-0.302-0.302-0.792,0-1.094l1.227-1.227 c0.302-0.302,0.792-0.302,1.094,0l1.227,1.227c0.302,0.302,0.302,0.792,0,1.094l-1.227,1.227 C37.245,20.076,36.755,20.076,36.453,19.773z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M26.5,25h-17C9.224,25,9,24.776,9,24.5v-1C9,23.224,9.224,23,9.5,23h17c0.276,0,0.5,0.224,0.5,0.5v1 C27,24.776,26.776,25,26.5,25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M36.453,25.773l-1.227-1.227c-0.302-0.302-0.302-0.792,0-1.094l1.227-1.227 c0.302-0.302,0.792-0.302,1.094,0l1.227,1.227c0.302,0.302,0.302,0.792,0,1.094l-1.227,1.227 C37.245,26.076,36.755,26.076,36.453,25.773z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M30.5,31h-21C9.224,31,9,30.776,9,30.5v-1C9,29.224,9.224,29,9.5,29h21c0.276,0,0.5,0.224,0.5,0.5v1 C31,30.776,30.776,31,30.5,31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M36.453,31.773l-1.227-1.227c-0.302-0.302-0.302-0.792,0-1.094l1.227-1.227 c0.302-0.302,0.792-0.302,1.094,0l1.227,1.227c0.302,0.302,0.302,0.792,0,1.094l-1.227,1.227 C37.245,32.076,36.755,32.076,36.453,31.773z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ReportCard);
export default __webpack_public_path__ + "static/media/icons8-report-card.82d2f553bf72344e7ca1cb125731f151.svg";
export { ForwardRef as ReactComponent };